import type { AiCompanyArticle } from '../types/news'

export function selectPublishedArchiveArticles(articles: AiCompanyArticle[], now = Date.now()): AiCompanyArticle[] {
  const byId = new Map<string, AiCompanyArticle>()
  const publicationTime = (article: AiCompanyArticle) => Date.parse(article.publishedAt ?? article.generatedAt)
  const revisionTime = (article: AiCompanyArticle) => article.revisedAt && Number.isFinite(Date.parse(article.revisedAt)) ? Date.parse(article.revisedAt) : publicationTime(article)
  for (const article of articles) {
    const published = publicationTime(article)
    if (article.publicationStatus === 'awaiting-human-review' || !Number.isFinite(published) || published > now
      || !/^[a-zA-Z0-9_-]+$/.test(article.id) || !article.headline.trim() || !article.dek.trim() || !article.sources.length) continue
    const previous = byId.get(article.id)
    if (!previous || revisionTime(article) >= revisionTime(previous)) byId.set(article.id, article)
  }
  return [...byId.values()].sort((left, right) => publicationTime(right) - publicationTime(left))
}
